import { Controller } from "@hotwired/stimulus"
import { loadGoogleMaps } from "../../src/shared/google_maps_loader"
import MapStyle from "src/shared/resources/map-style.json"
import MapStyleLight from "src/shared/resources/map-style-light.json"
import { pinIcon } from "../../src/shared/map_markers"
import { whenVisible } from "../../src/shared/when_visible"

export default class extends Controller {
  static values = {
    lat: Number,
    lng: Number,
    zoom: { type: Number, default: 16 },
    theme: { type: String, default: "default" },
    url: String
  }

  connect () {
    // Google Maps loads when the map nears the viewport, not with the page.
    this.stopWatching = whenVisible(this.element, () => this.initMap())
  }

  disconnect () {
    this.stopWatching?.()
    this.connection = null
    this.marker = null
    this.map = null
  }

  async initMap () {
    if (Number.isNaN(this.latValue) || Number.isNaN(this.lngValue)) return

    const connection = (this.connection = Symbol("connection"))
    try {
      const maps = await loadGoogleMaps()
      if (this.connection !== connection) return

      const center = { lat: this.latValue, lng: this.lngValue }

      this.map = new maps.Map(this.element, {
        center,
        zoom: this.zoomValue,
        styles: this.themeValue === "light" ? MapStyleLight : MapStyle,
        maxZoom: 19,
        disableDefaultUI: true,
        zoomControl: true,
        zoomControlOptions: {
          position: maps.ControlPosition.LEFT_TOP
        }
      })

      this.marker = new maps.Marker({
        position: center,
        map: this.map,
        icon: pinIcon(maps),
        optimized: false,
        cursor: "pointer"
      })
      this.marker.addListener("click", () => this.openMaps())
    } catch (_error) {
      // Keep the empty map container if the script fails to load.
    }
  }

  openMaps () {
    window.open(this.mapsUrl(), "_blank", "noopener,noreferrer")
  }

  mapsUrl () {
    if (this.hasUrlValue && this.urlValue) return this.urlValue

    return `https://maps.google.com/?q=${this.latValue},${this.lngValue}`
  }
}
